import React from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom'
import PaginationButtons from '../../../../PaginationButtons'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import HumanName from '../../../DataTypes/HumanName'
import { Practitioner } from '@teschglobal/tg-fhir-react-components/dist/types'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'
import FhirLoader from '../../../../FhirLoader'
import { PractitionerTable } from '@teschglobal/tg-fhir-react-components'

interface PractitionerListProps {
    practitioners: ProviderResponse<Practitioner>;
    clickViewDataLink: (organization: Practitioner) => void
    isFetching: boolean
    isLoading: boolean
    isSuccess: boolean
    searchProviderResource: { searchTerms: string, resource: string }
    clearForm: () => void
    newSearch: () => void
    updateSearchTerms: (e: React.ChangeEvent<HTMLInputElement>) => void
    totalPages: number;
    currentPage: number;
    handleChangePage: (page: number) => void;
}

const PractitionerList: React.FC<PractitionerListProps> = ({
    practitioners,
    clickViewDataLink,
    isFetching,
    isLoading,
    isSuccess,
    searchProviderResource,
    clearForm,
    newSearch,
    updateSearchTerms,
    totalPages,
    currentPage,
    handleChangePage
}) => {
    const { data: environment } = useEnvironment()
    const rows: Practitioner[] = practitioners?.data ?? []



    const handleNewSearch = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        newSearch()
    }


    return (
        <>
            <h3>Practitioner</h3>
            <Form noValidate className="d-flex align-items-center" onSubmit={handleNewSearch} role='form' aria-label='Search Practitioner'>

                <Form.Group className="d-flex align-items-center me-3 mb-0">
                    <Form.Label htmlFor='searchPractitioner' className="mb-0 me-2 text-nowrap">Search by Practitioner Name</Form.Label>
                    <Form.Control
                        id='searchPractitioner'
                        type="text"
                        name="keyword"
                        placeholder="Name"
                        value={searchProviderResource.searchTerms}
                        onChange={updateSearchTerms}
                    />
                </Form.Group>

                <Button variant="primary" className="btn-primary-custom" type="submit" id="searchButton">
                    Search
                </Button>
                <Button variant="primary-outline" type="reset" onClick={clearForm} id="clearButton">
                    Clear
                </Button>
            </Form>
            <hr />
            {(isLoading || isFetching) ? (
                <FhirLoader message='Loading...' />
            ) : (
                <>
                    {
                        practitioners?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <span role="status" aria-live="polite">{practitioners?.total.toLocaleString()} record(s) found</span>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                    <PractitionerTable
                        practitioners={rows}
                        onRowLinkClick={clickViewDataLink}
                    />
                    {
                        practitioners?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </>
    )
}

export default PractitionerList